// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1cNHE","updated_at":"updated_at__12mUU","updated_at_main":"updated_at_main__dAVdv","updated_at_paused":"updated_at_paused__2JYsU","time_updated":"time_updated__2CT_h","beacon":"beacon__1AqwB","beacon_success":"beacon_success__2Wuqc","beacon_error":"beacon_error__3NVie","beacon_stale":"beacon_stale__2FC5f"};


//////////////////
// WEBPACK FOOTER
// ./components/live-updated-time/style.scss
// module id = 76Ws
// module chunks = 0